import type {CourseInviteTarget} from '../../../../modules/invites/stores/types';
import type {SendInvitesResult} from './SendInvitesStrategy';
import type {SendInvitesParams} from './types';

import {inviteStore} from '../../../../api/invite';
import {AppError} from '../../../../utils/errors/app';
import {logger} from '../../../../utils/logger';
import {SendInvitesStrategy} from './SendInvitesStrategy';

export class SendInvitesToCourseStrategy extends SendInvitesStrategy {
  constructor(
    private readonly courseInviteTarget: CourseInviteTarget,
    private readonly params: SendInvitesParams,
  ) {
    super(params);
  }

  async sendInvites(): Promise<SendInvitesResult> {
    const {message, recipients, send_copy} = this.params;

    if (!recipients || recipients.length === 0) {
      throw new AppError('No recipients specified');
    }

    logger.event('invite_send_type', {
      message_added: this.params.message ? 'yes' : 'no',
      send_copy: this.params.send_copy ? 'yes' : 'no',
      type: 'course',
    });

    await inviteStore.sendToCourse({
      course_id: this.courseInviteTarget._id,
      message,
      program_id: this.courseInviteTarget.program_id,
      recipients: this.mapInviteRecipientsToRequestRecipients(recipients),
      send_copy,
    });

    return {
      message: this.getDefaultSuccessMessage(),
      title: this.getDefaultSuccessTitle(recipients.length),
    };
  }
}
